/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DidoSettings.vue?vue&type=template&id=66f0358c&scoped=true&"
import script from "./DidoSettings.vue?vue&type=script&lang=js&"
export * from "./DidoSettings.vue?vue&type=script&lang=js&"
import style0 from "./DidoSettings.vue?vue&type=style&index=0&id=66f0358c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f0358c",
  null
  
)

export default component.exports